import { Button } from '@mui/material';
import { Palette } from '@/themes/themeOverrides/Palette.js';

export default function OptionSelectButton({ label, icon, isActive = false, onClick, showRightBorder = false }) {
    return (
        <Button
            onClick={onClick}
            startIcon={icon}
            disableRipple
            sx={{
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                textAlign: 'left',
                gap: '8px',
                padding: '20px',
                borderRadius: 0,
                textTransform: 'none',
                fontWeight: 500,
                color: Palette.gray.gray800,
                backgroundColor: isActive ? Palette.white : Palette.gray.gray50,
                boxShadow: isActive ? Palette.boxShadow.elevation2 : 'none',
                borderRight: showRightBorder ? `2px solid ${Palette.gray.gray150}` : 'none',
                '& .MuiButton-startIcon': {
                    marginLeft: 0,
                    '& svg': {
                        width: '20px',
                        height: '20px',
                    },
                },
                '&:hover': {
                    backgroundColor: Palette.white,
                    boxShadow: 'none !important',
                },
            }}
        >
            {label}
        </Button>
    );
}
